import { EAS, SchemaEncoder, createOffchainURL } from '@ethereum-attestation-service/eas-sdk';
import { ethers } from 'ethers';
import { easContractAddress, easUId, easAttestationURL, adminPublicKey } from '../app.config';

interface OffChainAttestationParams {
  encodedData: string;
  user: any;
  refUID: string;
  timestamp: bigint;
  provider: any;
  signer?: ethers.Signer; // Optional explicit signer to avoid state issues
}

/**
 * Creates an off-chain attestation using the user's Magic wallet.
 * This ensures that both FROM and TO are the user's wallet address.
 */
export const createOffChainAttestation = async ({
  encodedData,
  user,
  refUID,
  timestamp,
  provider,
  signer: explicitSigner,
}: OffChainAttestationParams) => {
  try {
    // Get the signer from the user's Magic wallet
    // Use explicit signer if provided, otherwise get from provider
    const signer = explicitSigner || await provider.getSigner();
    const signerAddress = await signer.getAddress();
    const walletAddress = user?.walletAddress || signerAddress;
    
    console.log('=== Off-Chain Attestation Debug ===');
    console.log('Using explicit signer:', !!explicitSigner);
    console.log('Signer address (FROM):', signerAddress);
    console.log('Wallet address (TO):', walletAddress);
    console.log('User object wallet address:', user?.walletAddress);
    console.log('Admin public key:', adminPublicKey);
    console.log('Matched addresses:', signerAddress === walletAddress);

    // Initialize EAS with the user's signer (not admin)
    const eas = new EAS(easContractAddress!);
    await eas.connect(signer);

    // Get offchain attestation handler
    const offchain = await eas.getOffchain();

    // Create off-chain attestation signed by the user's wallet
    // This makes FROM and TO both be the user's wallet address
    const offchainAttestation = await offchain.signOffchainAttestation(
      {
        recipient: walletAddress,
        expirationTime: BigInt(0),
        time: timestamp,
        revocable: true,
        schema: easUId!,
        refUID: refUID,
        data: encodedData,
      },
      signer // User's signer from Magic wallet
    );

    console.log('Off-chain attestation:', offchainAttestation);

    const uid = offchainAttestation.uid;
    
    // Create the URL using the actual signer's address (user's wallet)
    // This ensures the attestation verifies correctly
    const url = createOffchainURL({ sig: offchainAttestation, signer: signerAddress });
    const fullUrl = easAttestationURL + url;
    
    console.log('Off-chain attestation URL:', fullUrl);
    console.log('FROM (signer address):', signerAddress);
    console.log('TO (recipient address):', walletAddress);
    console.log('=== End Debug ===');

    return { uid, url: fullUrl, signature: offchainAttestation };
  } catch (error) {
    console.error('Error creating off-chain attestation:', error);
    throw error;
  }
};

